var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{directives:[{name:"viewer",rawName:"v-viewer"}],staticStyle:{"max-width":"100%","object-fit":"cover"},style:({ width: _vm.width, height: _vm.height }),attrs:{"src":_vm.url,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }